"use strict";
// Copyright 2022 Fergal Daly <fergald@gmail.com>.
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsByDate = exports.EventSet = void 0;
exports.upgradeEvent = upgradeEvent;
exports.upgradeEvents = upgradeEvents;
exports.sortByDate = sortByDate;
const dates = require("../dates");
const maps = require("../maps");
function upgradeEvent(timezone, eventJson) {
    if (!eventJson.time) {
        return null;
    }
    const event = eventJson;
    event.simpleDate = timezone.getSimpleDateFromMs(eventJson.time);
    event.source = 'wix';
    return event;
}
function upgradeEvents(timezone, eventJsons) {
    const upgraded = [];
    for (const eventJson of eventJsons) {
        const event = upgradeEvent(timezone, eventJson);
        if (!event) {
            console.log("Couldn't upgrade event", eventJson);
            continue;
        }
        upgraded.push(event);
    }
    return upgraded;
}
function sortByDate(events) {
    return events.sort((e1, e2) => dates.compareNumbers(e1.time, e2.time));
}
class EventSet {
    constructor() {
        this.data = new Map();
    }
    makeKey(event) {
        return event.url || '';
    }
    add(event) {
        this.data.set(this.makeKey(event), event);
    }
    has(event) {
        return this.data.has(this.makeKey(event));
    }
    values() {
        return this.data.values();
    }
    size() {
        return this.data.size;
    }
}
exports.EventSet = EventSet;
class EventsByDate {
    constructor() {
        this.data = new Map();
    }
    add(event) {
        const dateKey = event.simpleDate.toString();
        maps.defaultTo(this.data, dateKey, () => new EventSet()).add(event);
    }
    has(event) {
        const dateKey = event.simpleDate.toString();
        const eventSet = this.data.get(dateKey);
        if (eventSet) {
            return eventSet.has(event);
        }
        return false;
    }
    get(date) {
        const dateKey = date.toString();
        return this.data.get(dateKey);
    }
}
exports.EventsByDate = EventsByDate;
